import EventBus from '@/bus'

if (!window.__POWERED_BY_QIANKUN__) {
    window.middleCallback = (page, res) => {
        EventBus.$emit('middleCallback:' + page, res)
    }
}



// WEBPACK FOOTER //
// ./src/utils/global.js